import './style/index.less';
import RegisterStep from './RegisterStep';

export * from './RegisterStep';

export default RegisterStep;
